import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useState } from "react";
import { useBoundStore } from "useStore";
import DragDTFile from "./DragDTFile";

const ImportButton = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const campaignManagerRows = useBoundStore(
    (state) => state.campaignManagerRows,
  );
  const importCmChanges = useBoundStore((state) => state.importCmChanges);
  const setCmPublishOpen = useBoundStore((state) => state.setCmPublishOpen);
  const setAlertState = useBoundStore((state) => state.setAlertState);
  const isDisabled = !campaignManagerRows || campaignManagerRows.length === 0;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleImport = (changes) => {
    setLoading(true);
    const appliedCount = importCmChanges(changes, campaignManagerRows);
    setLoading(false);
    handleClose();
    if (appliedCount === 0) {
      setAlertState({
        open: true,
        title: "Sin cambios detectados",
        message: "El archivo se procesó correctamente, pero los valores son idénticos a los actuales.",
        severity: "info",
      });
      return;
    }
    setCmPublishOpen(true);
  };

  return (
    <>
      <Tooltip title="Importar" placement="bottom" arrow>
        <span>
          <Button
            onClick={handleOpen}
            variant="contained"
            disabled={isDisabled}
            sx={{
              backgroundColor: "#354887",
              "&:hover": { backgroundColor: "#354887" },
              height: "45px",
              width: "20.5px",
              textTransform: "uppercase",
              padding: 0,
            }}
          >
            <FileUploadOutlinedIcon sx={{ width: 30, height: 30 }} />
          </Button>
        </span>
      </Tooltip>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Importar Campaign Manager</DialogTitle>
        <DialogContent>
          <DragDTFile loading={loading} onImport={handleImport} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImportButton;
